import React from 'react';
import PropTypes from 'prop-types';
import {
  AlertCircle,
  ArrowLeft,
  ArrowRight,
  ArrowUpLeft,
  BarChart2,
  Calendar,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Copy,
  Download,
  DownloadCloud,
  Edit3,
  Eye,
  FilePlus,
  Flag,
  Grid,
  HelpCircle,
  Image,
  Info,
  Layout,
  Link2,
  Lock,
  Mail,
  MapPin,
  Menu,
  Minus,
  MoreVertical,
  Paperclip,
  Phone,
  Plus,
  Pocket,
  RotateCw,
  Save,
  Search,
  Send,
  Settings,
  Share,
  Share2,
  Square,
  Star,
  Trash2,
  Type,
  UploadCloud,
  User,
  Video,
  X,
  XCircle
} from 'react-feather';

import { StyledSvgIcon } from '@vp-ui/components/VpIcon/styles';

import { LockedCircle, ReplyIcon, SelectCheckBoxIcon, Star as VpStar, InProgress } from '@vp-ui/svgs';
import {
  Amazon,
  Email,
  Facebook,
  Google,
  LinkedIn,
  Pinterest,
  Twitter,
  VpShare,
  Youtube
} from '@vp-ui/components/SocialMediaElement/SocialMediaIcon';

const IconMap = {
  AlertCircle,
  Amazon,
  ArrowLeft,
  ArrowRight,
  ArrowUpLeft,
  BarChart2,
  Calendar,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Copy,
  Download,
  DownloadCloud,
  Edit3,
  Email,
  Eye,
  Facebook,
  FilePlus,
  Flag,
  Google,
  Grid,
  HelpCircle,
  Image,
  Info,
  InProgress,
  Layout,
  Link2,
  LinkedIn,
  Lock,
  LockedCircle,
  Mail,
  MapPin,
  Menu,
  Minus,
  MoreVertical,
  Paperclip,
  Phone,
  Pinterest,
  Plus,
  Pocket,
  ReplyIcon,
  RotateCw,
  Save,
  Search,
  SelectCheckBoxIcon,
  Send,
  Settings,
  Share,
  Share2,
  Square,
  Star,
  Trash2,
  Twitter,
  Type,
  UploadCloud,
  User,
  Video,
  VpShare,
  VpStar,
  X,
  XCircle,
  Youtube
};

export const VpIcon = ({ icon = '', size = '', children, ...rest }) => {
  if (icon) {
    const IconComponent = IconMap[icon];

    return (
      <StyledSvgIcon size={size} {...rest}>
        <IconComponent />
      </StyledSvgIcon>
    );
  }

  return (
    <StyledSvgIcon size={size} {...rest}>
      {children}
    </StyledSvgIcon>
  );
};

VpIcon.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default VpIcon;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpIcon/VpIcon.jsx